export default __webpack_public_path__ + "static/media/logo.61b46f19.svg";